export default __webpack_public_path__ + "images/waves_59303c.svg";